var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1B3954;}\n\t.st1{fill:#16ADE1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.7,345.5H103v81c2.3-0.5,4.6-0.7,7-0.7c2.4,0,4.8,0.3,7,0.7v-81h24.9c0,0,0,0,0,0v40.3c0,3.9,3.1,7,7,7    s7-3.1,7-7v-40.3c0,0,0,0,0,0h152.5v81c2.3-0.5,4.6-0.7,7-0.7c2.4,0,4.7,0.3,7,0.7v-81h19.3v-30.2H83.7V345.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.7,452.2c0.5,2.3,0.7,4.6,0.7,7c0,2.4-0.3,4.8-0.7,7h140.1c-0.5-2.3-0.7-4.6-0.7-7c0-2.4,0.3-4.7,0.7-7    H142.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 110,
    cy: 459.2,
    r: 19.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 315.5,
    cy: 459.2,
    r: 19.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,420.7c0.3,0.3,0.7,0.6,1.1,0.9c0.4,0.3,0.8,0.5,1.2,0.6c0.4,0.2,0.9,0.3,1.3,0.4    c0.5,0.1,0.9,0.1,1.4,0.1c0.4,0,0.9,0,1.4-0.1c0.5-0.1,0.9-0.2,1.3-0.4c0.4-0.2,0.8-0.4,1.2-0.6c0.4-0.3,0.7-0.5,1.1-0.9    c0.3-0.3,0.6-0.7,0.9-1.1c0.3-0.4,0.5-0.8,0.6-1.2c0.2-0.4,0.3-0.9,0.4-1.3c0.1-0.5,0.1-0.9,0.1-1.4s-0.1-0.9-0.1-1.4    c-0.1-0.4-0.2-0.9-0.4-1.3c-0.2-0.4-0.4-0.8-0.6-1.2c-0.3-0.4-0.5-0.7-0.9-1.1c-0.3-0.3-0.7-0.6-1.1-0.9s-0.8-0.5-1.2-0.6    c-0.4-0.2-0.9-0.3-1.3-0.4c-0.9-0.2-1.8-0.2-2.7,0c-0.5,0.1-0.9,0.2-1.3,0.4c-0.4,0.2-0.8,0.4-1.2,0.6s-0.7,0.5-1.1,0.9    c-0.3,0.3-0.6,0.7-0.9,1.1c-0.3,0.4-0.5,0.8-0.6,1.2c-0.2,0.4-0.3,0.9-0.4,1.3c-0.1,0.5-0.1,0.9-0.1,1.4s0,0.9,0.1,1.4    c0.1,0.4,0.2,0.9,0.4,1.3c0.2,0.4,0.4,0.8,0.6,1.2C143.3,420.1,143.6,420.4,144,420.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 335.8,
    cy: 164.2,
    rx: 25.7,
    ry: 27.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.8,186.3H191c-7.3,0-13.3,5.9-13.3,13.3v4.3H88.9v-6.2c0-3.7-1.5-7-3.9-9.4c-2.4-2.4-5.7-3.9-9.4-3.9    c-7.3,0-13.3,5.9-13.3,13.3v25.4h228.4V186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.2,74.3h24.2h0v26.2c0,3.6,2.9,6.6,6.6,6.6h10.6v65.3h14v-65.3h10.6c3.6,0,6.6-2.9,6.6-6.6V49.8    c0-3.6-2.9-6.6-6.6-6.6H253c-3.6,0-6.6,2.9-6.6,6.6v10.5h0h-24.2V40.4c0-3.9-3.1-7-7-7s-7,3.1-7,7v131.9h14V74.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.7,160.7l-76.4,76.4H49.9v25h75.8c3.9,0,7,3.1,7,7c0,3.9-3.1,7-7,7H49.9v25.2h317l95.2-95.2      L416.7,160.7z M167.5,270.5c-0.1,0.5-0.2,0.9-0.4,1.3c-0.2,0.4-0.4,0.8-0.6,1.2s-0.6,0.7-0.9,1.1s-0.7,0.6-1.1,0.9      c-0.4,0.3-0.8,0.5-1.2,0.6c-0.4,0.2-0.9,0.3-1.3,0.4c-0.4,0.1-0.9,0.1-1.4,0.1c-1.8,0-3.6-0.8-4.9-2c-0.3-0.3-0.6-0.7-0.9-1.1      c-0.3-0.4-0.5-0.8-0.6-1.2c-0.2-0.4-0.3-0.9-0.4-1.3c-0.1-0.5-0.1-0.9-0.1-1.4c0-1.8,0.8-3.6,2.1-5c1.6-1.6,4.1-2.4,6.3-1.9      c0.4,0.1,0.9,0.2,1.3,0.4c0.4,0.2,0.8,0.4,1.2,0.6c0.4,0.3,0.7,0.5,1.1,0.9c1.3,1.3,2,3.1,2,5      C167.7,269.6,167.6,270,167.5,270.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBed);
export default __webpack_public_path__ + "static/media/hospital_bed.48f01d4d6bbd766561515cae0803016a.svg";
export { ForwardRef as ReactComponent };